module.exports = require("react-fontawesome");